import {
  useContext,
} from 'react';
import {Context} from '../contexts/WordList';
import {removeCategory as removeCategoryApi} from '../helpers/localApi';

export function useDeleteCategory(selectedKey, categoryToDelete) {
  const [state, dispatch] = useContext(Context);
  const {language} = state;

  const deleteCategory = async (selectedKey, categoryToDelete) => {
    if (selectedKey !== undefined && categoryToDelete !== undefined) {
      try {
        const response = await removeCategoryApi({
          language,
          id: selectedKey,
          category: categoryToDelete,
        });

        dispatch({
          type: 'REMOVE_CATEGORY_FROM_WORD',
          payload: {key: selectedKey, newTags: response.tags},
        });
      } catch (error) {
        console.error('Error deleting category: ', error);
      }
    }
  };

  return {deleteCategory};
};
